import { useLayer } from '@coursera-web/statsig';

const useUnifiedEnterpriseSearch = (): boolean => {
  return useLayer('enterprise-search-layer').get('unifiedEnterpriseSearch', false);
};

export default useUnifiedEnterpriseSearch;
